import { render, staticRenderFns } from "./CustomerTabSaleOrderList.vue?vue&type=template&id=284221fe&"
import script from "./CustomerTabSaleOrderList.vue?vue&type=script&lang=js&"
export * from "./CustomerTabSaleOrderList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTabSaleOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports